<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="mb-4">
                <b-col md="12" class="flex-column d-flex">
                  <b-row>
                    <b-col cols="12">
                      <ValidationProvider name="contact_country_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group>
                          <label>{{ $t('country') }}</label>
                          <country-selectbox ref="contactCountry" v-model="formData.contact_country_id" :disabled="!isCountryEnabled"
                                             :validateError="errors[0]">
                          </country-selectbox>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                    <div class="border rounded equal-height p-4 mb-4" v-if="isUSAddress">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group>
                                    <label>{{ $t('search_your_us_address') }}</label>
                                    <AddressSearchComponent
                                        :required="false"
                                        v-model="searchAddress"
                                        @selectedAddress="selected"/>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12">
                                <ValidationProvider name="contact_address" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group>
                                        <label>{{ $t('address') }}</label>
                                        <b-textarea v-model="formData.contact_address"
                                                      :state="errors[0] ? false : (valid ? true : null)">
                                        </b-textarea>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="6">
                                <ValidationProvider name="contact_state_id" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group>
                                        <label>{{ $t('state') }}</label>
                                        <state-selectbox v-model="formData.contact_state_id"
                                                        :validateError="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="6">
                                <ValidationProvider name="contact_city_id" rules="required"
                                                    v-slot="{ valid, errors }">
                                    <b-form-group>
                                        <label>{{ $t('city') }}</label>
                                        <city-selectbox v-model="formData.contact_city_id"
                                                                    :state_id="formData.contact_state_id"
                                                                    :validateError="errors[0]"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="6">
                                <ValidationProvider name="apartment" rules="" v-slot="{ valid, errors }">
                                    <b-form-group>
                                        <label>{{ $t('apartment') }}</label>
                                        <b-form-input type="text" v-model="formData.apartment"
                                                      :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="6">
                                <ValidationProvider name="contact_zip_code" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group>
                                        <label>{{ $t('zip_code') }}</label>
                                        <b-form-input type="text" v-model="formData.contact_zip_code"
                                                      :state="errors[0] ? false : (valid ? true : null)">
                                        </b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </div>
                  <div class="border rounded equal-height p-4 mb-4" v-else>
                    <b-row>
                      <b-col cols="12">
                        <b-form-group>
                          <label>{{ $t('search_your_address') }}</label>
                          <AddressSearchComponent
                              :required="false"
                              v-model="searchAddress"
                              :country="country_code"
                              :disabled="!country_code"
                              @selectedAddress="selected"/>
                        </b-form-group>
                      </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="contact_address" rules="required" v-slot="{ valid, errors }">
                                <b-form-group>
                                    <label>{{ $t('state') }}</label>
                                    <b-form-input v-model="formData.contact_state"
                                                :state="errors[0] ? false : (valid ? true : null)">
                                    </b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider name="contact_address" rules="required" v-slot="{ valid, errors }">
                                <b-form-group>
                                    <label>{{ $t('city') }}</label>
                                    <b-form-input v-model="formData.contact_city"
                                                :state="errors[0] ? false : (valid ? true : null)">
                                    </b-form-input>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                      <b-col cols="12">
                        <ValidationProvider name="contact_address" rules="required" v-slot="{ valid, errors }">
                          <b-form-group>
                            <label>{{ $t('address') }}</label>
                            <b-textarea v-model="formData.contact_address"
                                          :state="errors[0] ? false : (valid ? true : null)">
                            </b-textarea>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>

                      <b-col cols="6">
                        <ValidationProvider name="contact_zip_code" rules="required" v-slot="{ valid, errors }">
                          <b-form-group>
                            <label>{{ $t('zip_code') }}</label>
                            <b-form-input type="text" v-model="formData.contact_zip_code"
                                          :state="errors[0] ? false : (valid ? true : null)">
                            </b-form-input>
                          </b-form-group>
                        </ValidationProvider>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center">
                <b-button variant="primary" @click="updateForm" :disabled="formProcess">
                    {{ $t('save') }}
                </b-button>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
// Components
import CountrySelectbox from '@/components/interactive-fields/CountrySelectbox';
import StateSelectbox from '@/components/interactive-fields/StateSelectbox';
import CitySelectbox from '@/components/interactive-fields/CitySelectbox';

// Services
import StudentProgramService from '@/services/StudentProgramService'

// Other
import {ValidationObserver, ValidationProvider} from 'vee-validate'
import AddressSearchComponent from "@/components/interactive-fields/AddressSearchComponent.vue";

export default {
    components: {
        StateSelectbox,
        CountrySelectbox,
        CitySelectbox,
        AddressSearchComponent,

        ValidationProvider,
        ValidationObserver
    },
    props: {
        studentProgram: {
            type: Object,
            default: null
        }
    },
    created() {
        this.formId = this.studentProgram.id;
        this.formData = {
            contact_address: this.studentProgram.contact_address,
            contact_country_id: this.studentProgram.contact_country_id,
            contact_state_id: this.studentProgram.contact_state_id,
            contact_zip_code: this.studentProgram.contact_zip_code,
            apartment: this.studentProgram.apartment,
            contact_city_id:this.studentProgram.contact_city_id,
            contact_state:this.studentProgram.contact_state,
            contact_city:this.studentProgram.contact_city
        }
        this.isUSAddress = this.studentProgram.contact_country_code==='US'
        this.country_code=this.studentProgram.contact_country_code
    },
    computed:{
      isCountryEnabled(){
        if(!this.studentProgram.contact_country_id || ['102','202'].includes(this.studentProgram.student_status) || !this.isUSAddress){
          return true;
        }

        return false;
      }
    },
    mounted() {
        this.$refs.formModalValidate.reset();
    },
    data() {
        return {
            formId: null,
            formData: {
                contact_country_id:null,
                contact_state:null,
                contact_city:null,
            },
            formProcess: false,
            searchAddress: null,
            isUSAddress:true,
            country_code:null,
        }
    },
    methods: {
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formProcess = true;
                StudentProgramService.updateAddress(this.formId, this.formData)
                    .then(response => {
                        this.$emit('updateFormSuccess', true);
                        this.$toast.success(this.$t('api.' + response.data.message));
                    })
                    .catch((e) => {
                        this.showErrors(e, this.$refs.formModalValidate)
                    })
                    .finally(() => {
                        this.formProcess = false
                    })
            }
        },
        selected(event) {
          if(this.isUSAddress){
            this.formData.contact_state_id = event.state_id
            this.formData.contact_city_id = event.city_id
          }
          else {
            this.formData.contact_state = event.state
            this.formData.contact_city = event.city
          }

          let address = '';
          if(this.isUSAddress){
            if(event.street_number){
              address += event.street_number + ' ';
            }
            if(event.street_name){
              address += event.street_name + ' ';
            }
            if(event.neighbourhood){
              address += event.neighbourhood + ' ';
            }
            if(event.district){
              address += event.district;
            }
          }
          else {
            if(event.neighbourhood){
              address += event.neighbourhood + ' ';
            }
            if(event.street_name){
              address += event.street_name + ' ';
            }
            if(event.street_number){
              address += event.street_number + ' ';
            }
            if(event.district){
              address += event.district;
            }
          }


            this.formData.contact_zip_code = event.zip_code
            this.formData.contact_address = address
        },
    },
    watch:{
      'formData.contact_country_id':{
          handler(newVal){
              if (newVal){
                  this.$nextTick(()=>{
                      let country=this.$refs.contactCountry.getItem(newVal);
                      if (country)  {
                        this.isUSAddress = country?.code==='US'
                        this.country_code=country?.code
                      }

                  })
              }
        }
      },
    }
}
</script>
